<template>
  <v-container fluid tag="section" v-if="data">
    <v-row>
      <v-col cols="12" :md="mini ? 3 : 4" class="size-13 pb-1">
        客户名称：<span class="grey--text text--darken-1">{{data.name}}</span>
        ({{data.createTime | formatDay}})
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
        客户类型：<span class="grey--text text--darken-1">{{data.typeDic === null || data.typeDic === undefined  ? '' : data.typeDic.name}}</span>
      </v-col>
       <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
        客户来源：<span class="grey--text text--darken-1">{{data.fromDic === null || data.fromDic === undefined ? '' : data.fromDic.name}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
        重要程度：<span class="grey--text text--darken-1">{{data.degreeDic  === null || data.degreeDic  === undefined ? '' : data.degreeDic.name}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
        客户阶段：<span class="grey--text text--darken-1">{{data.stageDic === null || data.stageDic === undefined ? '' : data.stageDic.name}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
        首推项目：<span class="grey--text text--darken-1">{{data.stageDesc || '无'}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
        客户性质：<span class="grey--text text--darken-1">{{data.natureDic === null || data.natureDic === undefined ? '' : data.natureDic.name}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
        客户行业：<span class="grey--text text--darken-1">{{data.tradeDic === null || data.tradeDic === undefined ? '' : data.tradeDic.name}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 3 : 4" class="size-13 py-1">
        客户等级：<span class="grey--text text--darken-1">{{data.levelDic === null || data.levelDic === undefined ? '' : data.levelDic.name}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="size-13 py-1">
        <strong v-if="!$isMobile">客户地址：</strong><span class="grey--text text--darken-1">{{data.contactsAddress}}</span>
      </v-col>
    </v-row>
    <div v-if="data.detail">
      <v-divider class="my-4"></v-divider>
      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4" class="size-13 py-1">
          成立年度：<span class="grey--text text--darken-1">{{data.detail === null  ? '' : data.detail.createYear}}年</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" class="size-13 py-1">
          知识产权：<span class="grey--text text--darken-1">{{data.detail === null  ? '' : data.detail.patentNumber}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" class="size-13 py-1">
          员工数量：<span class="grey--text text--darken-1">{{data.detail === null  ? '' : data.detail.workers}}</span>
        </v-col>
      </v-row>
      <v-row>
      <v-col cols="12" class="size-13 py-1">
        企业资质：<span class="grey--text text--darken-1">{{data.detail === null  ? '' : data.detail.seniorityStr}}</span>
      </v-col>
    </v-row>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import { getById } from '@/api/customer/index.js'

  export default {
    name: 'CustomerDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      lazy: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        data: this.item
      }
    },
    methods: {
      loadData () {
        if (this.item && this.item.id) {
          this.loading = true
          getById(this.item.id).then(res => {
            if (res.status === 200) {
              this.data = res.data
            }
            this.loading = false
          })
        }
      }
    },
    created () {
      if (this.lazy) {
        this.loadData()
      }
    }
  }
</script>

<style>
</style>
